import React from "react";
import { Stack, Box, Divider, Typography, Link } from "@mui/material";
import { DoubleArrow } from "@mui/icons-material";

const pages = ["mainSection", "aboutUs", "serviceUs", "contactUs"];

export const FooterTwo = ({ translate }) => {
  return (
    <Box>
      <Box>
        <Typography variant="h6">
          <b>{translate("linkFooter")}</b>
        </Typography>
      </Box>
      <Divider sx={{ border: "2px solid #669944", width: "160px", my: 1 }} />
      <Box>
        <Stack direction="column" pl={2}>
          {pages.map((page) => (
            <Link
              href={`#${page}`}
              key={page}
              underline="none"
              sx={{
                color: "white",
                display: "block",
                "&:hover": {
                  color: "#669944",
                },
                padding: "5px",
              }}
            >
              <Stack direction="row" alignItems="center">
                <DoubleArrow sx={{ fontSize: "16px" }} />
                <Typography
                  variant="body1"
                  sx={{
                    paddingLeft: "10px",
                  }}
                >
                  {translate(`${page}`)}
                </Typography>
              </Stack>
            </Link>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};
